"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENGAGEMENT_FILTER_TYPE_TO_ENGAGEMENT_TYPES = exports.ENGAGEMENTS_TASKS = exports.ENGAGEMENTS_CALLS = exports.ENGAGEMENTS_EMAIL = exports.ENGAGEMENTS_NOTES = exports.ENGAGEMENTS_ACTIVITY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _Map;

var ENGAGEMENTS_ACTIVITY = 'ENGAGEMENTS_ACTIVITY';
exports.ENGAGEMENTS_ACTIVITY = ENGAGEMENTS_ACTIVITY;
var ENGAGEMENTS_NOTES = 'ENGAGEMENTS_NOTES';
exports.ENGAGEMENTS_NOTES = ENGAGEMENTS_NOTES;
var ENGAGEMENTS_EMAIL = 'ENGAGEMENTS_EMAILS_TRIMMED';
exports.ENGAGEMENTS_EMAIL = ENGAGEMENTS_EMAIL;
var ENGAGEMENTS_CALLS = 'ENGAGEMENTS_CALLS';
exports.ENGAGEMENTS_CALLS = ENGAGEMENTS_CALLS;
var ENGAGEMENTS_TASKS = 'ENGAGEMENTS_TASKS';
exports.ENGAGEMENTS_TASKS = ENGAGEMENTS_TASKS;
var ENGAGEMENT_FILTER_TYPE_TO_ENGAGEMENT_TYPES = (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, ENGAGEMENTS_NOTES, (0, _immutable.List)([_EngagementTypes.default.NOTE])), (0, _defineProperty2.default)(_Map, ENGAGEMENTS_EMAIL, (0, _immutable.List)([_EngagementTypes.default.EMAIL, _EngagementTypes.default.EMAIL_ACTIVITY, _EngagementTypes.default.INCOMING_EMAIL, _EngagementTypes.default.FORWARDED_EMAIL])), (0, _defineProperty2.default)(_Map, ENGAGEMENTS_CALLS, (0, _immutable.List)([_EngagementTypes.default.CALL])), (0, _defineProperty2.default)(_Map, ENGAGEMENTS_TASKS, (0, _immutable.List)([_EngagementTypes.default.TASK])), _Map));
exports.ENGAGEMENT_FILTER_TYPE_TO_ENGAGEMENT_TYPES = ENGAGEMENT_FILTER_TYPE_TO_ENGAGEMENT_TYPES;